import { ResourceState, ResourceData } from '@lfw/roesberg.liveforms.core';

export class ResourceHelper {
  static filterResourcesByOrderAndState(
    resourceData: ResourceData[],
    states: ResourceState[],
    orderId: string
  ): ResourceData[] {
    return resourceData.filter((resource) => {
      const stateMatches = states.includes(resource.state);
      const orderMatches = resource.orderId === orderId;
      return stateMatches && orderMatches;
    });
  }
}
